export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string) {
    super(code);
  }
}

export function userFacingError(error: unknown): string {
  if (!(error instanceof ApiError)) return '连接未完成，请检查网络后重试。';
  if (error.status === 401) return '登录已失效，请重新登录后继续。';
  if (error.status === 403) return '当前账号没有此操作权限。';
  const messages: Record<string, string> = {
    unsupported_stock_code: '请输入沪、深、北 A 股代码；当前不支持指数、基金或境外股票。',
    research_document_not_found: '该证据文档不存在，请按股票代码重新查询。',
    report_not_found: '这份报告不存在或当前账号无权查看，请检查链接。',
    job_not_found: '这个任务不存在或当前账号无权查看，请检查链接。',
    stock_analysis_evidence_insufficient: '暂未取得该股票有效且足够新的行情证据，未建立分析任务；请核对代码或稍后重试。',
    stock_research_unavailable: '暂未取得该股票的有效研究资料，请稍后重试。',
    research_run_not_found: '该实验版本不存在，请检查链接。',
    stock_not_in_analysis_snapshot: '该股票不在当前可分析快照中，尚无可用证据；请从研究观察池选择。',
    stock_not_in_public_observation_pool: '该股票不在当前研究观察池，请从观察池选择。',
    stock_not_in_signal_snapshot: '该股票不属于当前研究快照，请刷新后重新选择。',
    signal_snapshot_not_found: '当前研究快照不可用，请刷新后重试。',
    daily_analysis_quota_exceeded: '今日分析额度已用完，请先查看已有任务和报告。',
    batch_exceeds_remaining_quota: '所选数量超过今日剩余额度，请减少数量。',
    paper_order_not_pending: '该委托状态已变化，请刷新委托记录。',
    insufficient_cash: '模拟账户可用资金不足，请调整数量。',
    insufficient_position: '可卖持仓不足，请核对账户和数量。',
    validation_failed: '提交内容不符合要求，请检查输入后重试。'
  };
  return messages[error.code] ?? (error.status === 429 ? '请求过于频繁，请稍后重试。' : error.status >= 500 ? '服务暂时不可用，请稍后重试。' : '操作未完成，请刷新后重试。');
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    credentials: 'same-origin',
    ...init,
    headers: {
      ...(init.body ? { 'content-type': 'application/json' } : {}),
      ...init.headers
    }
  });
  const payload = await response.json().catch(() => ({})) as Record<string, unknown>;
  if (!response.ok) throw new ApiError(response.status, String(payload.error ?? `http_${response.status}`));
  return payload as T;
}

export function post<T>(path: string, body: unknown): Promise<T> {
  return api<T>(path, { method: 'POST', body: JSON.stringify(body) });
}
